import { Platform, StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR, lightGrey, whiteTransparent } from 'utils/colors';
import {
    heightPercentageToDP,
    isPhone,
    isTablet,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    bottomStyle: {
        flexDirection: 'column',
        marginTop: 32,
        ...(isTabletOrWeb
            ? {}
            : {
                  position: 'absolute',
                  bottom: 0,
              }),
    },
    topLogo: {
        justifyContent: 'center',
        alignSelf: 'center',
        marginTop: Platform.select({
            web: 120,
            default: 64,
        }),
        marginBottom: Platform.select({ default: isTablet ? 64 : 64, web: 80 }),
    },
    forgotPasswordView: {
        width: widthPercentageToDP(328),
    },
    forgotPassword: {
        alignSelf: 'flex-start',
        fontFamily: Fonts.main.regular,
        color: lightGrey(),
        fontSize: 16,
        lineHeight: 20,
        marginTop: 16,
    },
    bottomEmptySpace: {
        flex: isTabletOrWeb ? 3 : 2.3,
    },
    tryAgainButtonTablet: {
        width: 'auto',
        minWidth: 120,
        paddingVertical: 8,
        paddingHorizontal: 18,
    },
    tryAgainButtonText: {
        color: COLOR.background,
    },
    errorDescription: {
        marginTop: heightPercentageToDP(16),
    },
    privacyPolicyContent: {
        flexWrap: 'wrap',
        justifyContent: 'center',
        marginBottom: isPhone ? 0 : 40,
    },
    privacyPolicyText: {
        lineHeight: 20,
    },
    button: {
        width: widthPercentageToDP(328),
    },
    qrButton: {
        borderWidth: isTablet ? 2 : 1.5,
        borderColor: isTablet ? whiteTransparent(0.3) : whiteTransparent(0.7),
    },
    qrButtonText: {
        color: COLOR.WHITE,
        marginLeft: 8,
    },
});

export default styles;
